<script lang="ts">
  import type { OrgaViewFrameContext } from "../../../../context"
  import type { PageContext } from "../../_shared/_logic/customer-registry-index"
  import CustomersTable from "./_modules/customers-table"

  const { viewFrameContext } = $props<{
    viewFrameContext: OrgaViewFrameContext
  }>()
  const pageContext = $derived<PageContext>({
    organization: viewFrameContext.organization,
    canEditCustomers: !viewFrameContext.trialRestrictionsActive,
    isFreeTrialExperience: viewFrameContext.isFreeTrialExperience,
    trialRestrictionsActive: viewFrameContext.trialRestrictionsActive,
  })
</script>

<CustomersTable {viewFrameContext} {pageContext} />
